module.exports = __webpack_public_path__ + "static/media/china.7f8455b7.svg";